module.exports = __webpack_public_path__ + "img/hermon_yes.516a8e42.png";